import { createSlice } from "@reduxjs/toolkit";

const initialSupplierState = {
    listLoading: false,
    actionsLoading: false,
    totalCount: 0,
    entities: null,
    supplierDetails: undefined,
    lastError: null,
};

export const callTypes = {
    list: "list",
    action: "action",
};

export const supplierSlice = createSlice({
    name: "suppliers",
    initialState: initialSupplierState,
    reducers: {
        catchError: (state, action) => {
            state.error = `${action.type}: ${action.payload.error}`;
            if (action.payload.callType === callTypes.list) {
                state.listLoading = false;
            } else {
                state.actionsLoading = false;
            }
        },
        startCall: (state, action) => {
            state.error = null;
            if (action.payload.callType === callTypes.list) {
                state.listLoading = true;
            } else {
                state.actionsLoading = true;
            }
        },
        endCall: (state, action) => {
            state.error = null;
            if (action.payload.callType === callTypes.list) {
                state.listLoading = false;
            } else {
                state.actionsLoading = false;
            }
        },
        // getSuppliers
        suppliersFetched: (state, action) => {
            const { totalCount, entities } = action.payload;
            state.listLoading = false;
            state.entities = entities;
            state.totalCount = totalCount;
            state.error = null;
        },
        //getSupplierDetails
        supplierDetailsFetched: (state, action) => {
            const { supplierDetails } = action.payload;
            state.actionsLoading = false;
            if(supplierDetails) delete supplierDetails.password;
            if(supplierDetails ) delete supplierDetails.service_password;
            state.supplierDetails = supplierDetails;
            state.error = null;
        },
        // updateSupplier
        supplierUpdated: (state, action) => {
            state.error = null;
            state.actionsLoading = false;
            // state.supplierDetails = action.payload.supplier;
        },
        supplierCreated: (state, action) => {
            state.actionsLoading = false;
            state.error = null;
            // state.entities.push(action.payload.customer); //push in existing list
        },
        // deleteCustomer
        supplierDeleted: (state, action) => {
            state.error = null;
            state.actionsLoading = false;
            state.entities = state.entities.filter(
                (el) => el._id !== action.payload.supplier_id
            );
        },
    },
});
